import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { OperatorsSelect } from '@/tools/OperatorsSelect.molecule';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { OPERATOR } from '@/toolSelection/investigate.constants';

export interface OperatorSelectIF extends ValidatingFormComponent<any> {
  component: 'OperatorSelectFormComponent';
  operators: readonly OPERATOR[];
  disabled?: boolean;
  onChange: (entryCondition: any) => void;
  formattedOptions?: boolean;
  placeholder?: string;
  inputGroup?: 'left' | 'right';
}

export const OperatorSelectFormComponent = (props: OperatorSelectIF) => {
  const { name, validation, extendValidation, testId, extraClassNames, inputGroup } = props;
  const defaultValidation = _.isEmpty;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <div
      {...stylex.props(styles.wrapper, props.xstyle)}
      className={clsx(stylex.props(styles.wrapper, props.xstyle).className, extraClassNames)}
      data-testid={testId}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);

          return (
            <OperatorsSelect
              {...formFieldProps}
              xstyle={undefined}
              onChange={(operator) => {
                props.onChange(operator);
                input.onChange(operator?.value);
              }}
              appendToBody={true}
              showError={formFieldProps.showError}
              inputGroup={inputGroup}
            />
          );
        }}
      </Field>
    </div>
  );
};

const styles = stylex.create({ wrapper: { marginBottom: '.5rem' } });
